(function () {
    const html = document.documentElement;
    const icon = document.getElementById('icon-theme-toggle');
    const toggle = document.getElementById('theme-toggle');

    function prefersDarkTheme() {
        return globalThis.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    function effectiveTheme() {
        return html.dataset.theme || (prefersDarkTheme() ? 'dark' : 'light');
    }

    function applyTheme(theme) {
        html.dataset.theme = theme;
        if (icon) {
            icon.classList.toggle('moon', theme === 'dark');
        }
    }

    const stored = globalThis.localStorage.getItem('cairos-theme');
    if (stored) {
        applyTheme(stored);
    } else if (prefersDarkTheme() && icon) {
        icon.classList.add('moon');
    }

    if (!toggle) {
        return;
    }

    toggle.addEventListener('click', function () {
        const next = effectiveTheme() === 'dark' ? 'light' : 'dark';
        globalThis.localStorage.setItem('cairos-theme', next);
        applyTheme(next);
    });
})();
